<div class="lvi-content">
    <div class="avatar">
        <i *ngIf="data?.type ===  TypeMessageNotif.CONFIRMATION" class="material-icons-outlined">mark_email_read</i>
        <i *ngIf="data?.type !==  TypeMessageNotif.CONFIRMATION" class="material-icons-outlined">mail</i>
    </div>

    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="goToDetailMessage()">
                {{ data?.titre }} <span *ngIf="data?.sujet">- {{ data?.sujet }}</span>
            </a>
        </div>

        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.message.labels.type'"></strong>
                <span>{{ getLibelleType() }}</span>
            </li>

            <li *ngIf="data?.use === false">
                <strong [translate]="'admin.bibliotheque.notifications.message.labels.utilise'"></strong>
                <span>{{ getLibelleUtilise() }}</span>
            </li>
        </ul>
    </div>

    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteMessage()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>